import { render } from "./UnauthenticatedLayout.vue?vue&type=template&id=13afc297"
import script from "./UnauthenticatedLayout.vue?vue&type=script&lang=js"
export * from "./UnauthenticatedLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__